import { FilterEventType, Paginated } from "@ac-expo/api-types";

const touristicPlacesQueryKeys = {
  all: ["touristic-places"] as const,
  me: () => [...touristicPlacesQueryKeys.all, "me"] as const,
  get: (id: string) => [...touristicPlacesQueryKeys.all, "get", id] as const,
  list: (params: string) =>
    [...touristicPlacesQueryKeys.all, "list", params] as const,
  detail: (id: string) =>
    [...touristicPlacesQueryKeys.all, "detail", id] as const,
};

export const acExpoTouristicPlacesQueryKeys = {
  all: ["touristic-places-acexpo"] as const,
  list: (params: Paginated<FilterEventType | object>) =>
    [...acExpoTouristicPlacesQueryKeys.all, "list", params] as const,
};

export default touristicPlacesQueryKeys;
